import AuthDrawer from "../../components/AuthDrawer";
import * as React from "react";
import {Box} from "@mui/material";
import jetLogo from "../../assets/logos/jet-travel-logo-white.svg"

const Home = () => {
    document.title = 'Üdvözöljük!'
    console.log('HOME')

    return <AuthDrawer label='Üdvözöljük!'>
        <Box sx={{width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#ddd', borderRadius: '8px'}}>
            <img src={jetLogo} alt="jet travel logo" style={{width: '50%'}}/>
        </Box>
    </AuthDrawer>
}

export default Home